module.exports = __webpack_public_path__ + "static/img/home-im.6c6dc063.png";